export default __webpack_public_path__ + "static/media/coming_soon.fa8c85e9.jpg";